import React, { createContext, useState, useContext, useEffect } from "react";
import { Me } from "../store/domains/Me";
import { Api } from "../common/Api";

type AppContextType = {
  me: Me;
  loadMe: () => void;
};
const AppContext = createContext<AppContextType>({
  me: new Me({}),
  loadMe: () => {},
});

export const AppProvider: React.FC = ({ children }) => {
  const [me, setMe] = useState<Me>(new Me({}));

  const loadMe = () => {
    Api.me
      .me()
      .then((res) => {
        setMe(Object.assign(new Me({}), res.data.me));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    loadMe();
  }, []);

  return <AppContext.Provider value={{ me, loadMe }}>{children}</AppContext.Provider>;
};

export const useAppContext = () => useContext(AppContext);
